import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { DOC_TYPES } from "@/lib/util";
import { Field } from "@/components/common";
import Modal from "@/components/Modal";
import { FileInput } from "@/pages/admin/ui";
import DateInput from "@/components/DateInput";

export default function DocUploadModal({ open, onClose, driverId, vehicleId, doc, onSaved }) {
  const [f, setF] = useState({});
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) {
      setF({ doc_type: doc?.doc_type || "civil_id", number: doc?.number || "", issue_date: doc?.issue_date || "", expiry_date: doc?.expiry_date || "",
        visible_to_driver: doc ? doc.visible_to_driver : true });
      setFile(null);
    }
  }, [open, doc]);
  const save = async () => {
    if (!doc && !file) return toast.error("اختر الملف (صورة أو PDF)");
    setBusy(true);
    const fd = new FormData();
    Object.entries(f).forEach(([k, v]) => fd.append(k, String(v)));
    if (driverId) fd.append("driver_id", driverId);
    if (vehicleId) fd.append("vehicle_id", vehicleId);
    if (file) fd.append("file", file);
    try {
      if (doc) await api.put(`/documents/${doc.id}`, fd); else await api.post("/documents", fd);
      toast.success("تم حفظ المستند");
      onSaved && onSaved();
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <Modal open={open} onClose={onClose} title={doc ? `تحديث: ${doc.name}` : "رفع مستند"} testid="doc-upload-modal">
      <div className="space-y-3">
        {!doc && <Field label="نوع المستند"><select data-testid="doc-type-select" className="field" value={f.doc_type} onChange={set("doc_type")}>
          {Object.entries(DOC_TYPES).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></Field>}
        <Field label="رقم المستند"><input data-testid="doc-number" className="field" value={f.number || ""} onChange={set("number")} /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="تاريخ الإصدار"><DateInput testid="doc-issue" value={f.issue_date || ""} onChange={set("issue_date")} /></Field>
          <Field label="تاريخ الانتهاء"><DateInput testid="doc-expiry" value={f.expiry_date || ""} onChange={set("expiry_date")} /></Field>
        </div>
        <Field label={doc ? "ملف جديد (اختياري)" : "الملف (صورة أو PDF، حتى 10MB)"}><FileInput testid="doc-file" onChange={setFile} /></Field>
        {driverId && <label className="flex items-center gap-2 font-bold"><input data-testid="doc-visible" type="checkbox" className="w-5 h-5" checked={!!f.visible_to_driver}
          onChange={(e) => setF({ ...f, visible_to_driver: e.target.checked })} />يستطيع السائق مشاهدة هذا المستند</label>}
        <button data-testid="doc-save-btn" disabled={busy} onClick={save} className="btn btn-lg btn-green w-full">{busy ? "جاري الرفع..." : "حفظ المستند"}</button>
      </div>
    </Modal>
  );
}
